import React, { createContext, useState, useEffect, useContext } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('ananta_language') || '';
  });

  const [isModalOpen, setIsModalOpen] = useState(() => {
    // Show modal if the user hasn't selected a language yet
    return !localStorage.getItem('ananta_language');
  });

  const [isMuted, setIsMuted] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  // Fallback to 'en' if language is not set or modal is open
  const activeLanguage = language || 'en';

  const selectLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('ananta_language', lang);
    setIsModalOpen(false);
    
    // Crucial Voice Play Optimization:
    // Once they select a language (which is a click interaction), 
    // we immediately enable sound globally and mark interaction as true.
    setIsMuted(false);
    setHasInteracted(true);
  };

  const t = (key) => {
    return translations[activeLanguage]?.[key] || translations['en']?.[key] || key;
  };

  // Allow clicking anywhere to unmute as a secondary fallback
  useEffect(() => {
    const handleGlobalClick = () => {
      if (!hasInteracted) {
        setIsMuted(false);
        setHasInteracted(true);
      }
    };
    window.addEventListener('click', handleGlobalClick);
    return () => window.removeEventListener('click', handleGlobalClick);
  }, [hasInteracted]);

  return (
    <LanguageContext.Provider value={{
      language: activeLanguage,
      rawLanguage: language,
      selectLanguage,
      isModalOpen,
      setIsModalOpen,
      t,
      isMuted,
      setIsMuted,
      hasInteracted,
      setHasInteracted
    }}>
      {children}
    </LanguageContext.Provider>
  );
};
export default LanguageContext;
